/**
 * @generated SignedSource<<9d97d2ef6506e9a97136336667f3dacc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleVocabBoxArticle$data = {
  readonly glossary: ReadonlyArray<{
    readonly description: {
      readonly json: Schema | null;
    } | null;
    readonly term: string;
    readonly translation: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"contentSchemaRenderContent">;
  readonly " $fragmentType": "articleVocabBoxArticle";
};
export type articleVocabBoxArticle$key = {
  readonly " $data"?: articleVocabBoxArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleVocabBoxArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleVocabBoxArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Glossary",
      "kind": "LinkedField",
      "name": "glossary",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "term",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "translation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FormattedValue",
          "kind": "LinkedField",
          "name": "description",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "json",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSchemaRenderContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "120714e98bcb0de017a289d35a2b8d60";

export default node;
